import React from 'react';
import Image from '../assets/NewHome/image1.jpg';

const StatsCards = () => {
  // Data from CaseStudyCarousel.js
  const caseStudyData = {
    clientName: 'Samsung Galaxy',
    clientDescription: 'Automation of routine tasks with AI to focus on higher-value tasks.',
    testimonial: "Automate your consulting sales process and increase winnability. Get actionable lead signals tailored to your offerings and past work, while intelligently tracking your focus accounts and key people. Make your business development efforts timely and consistent by proactively building a pipeline.",
    stats: [
      { 
        number: '3X', 
        description: 'More proposals sent to clients by reducing a lot of manual work' 
      },
      { 
        number: '60%', 
        description: 'Time saved on research, spend more time on billable work' 
      },
      { 
        number: '45%', 
        description: 'Automation of routine tasks with AI to focus on higher-value tasks.' 
      }
    ]
  };

  return (
    <>
      {/* Testimonial Section */}
      <section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16 mt-20">
        <div className="max-w-7xl mx-auto w-full px-10">
          <div className="bg-white rounded-2xl">
            {/* Top Section - Image and Company Info */}
            <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 md:gap-10 items-start sm:items-center mb-6 sm:mb-8">
              {/* Circular Profile Image */}
              <div className="flex-shrink-0">
                <div className="w-36 h-60 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full overflow-hidden border-2 border-gray-100 shadow-sm">
                  <img 
                    src={Image}
                    alt={caseStudyData.clientName}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Company Name and Description */}
              {/* <div className="flex-1">
                <h2 
                  className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4"
                  style={{ 
                    color: '#171717',
                    fontFamily: "'Bricolage Grotesque', sans-serif"
                  }}
                >
                  {caseStudyData.clientName}
                </h2>
                <p 
                  className="text-base sm:text-lg md:text-xl font-normal leading-relaxed"
                  style={{ 
                    color: '#171717',
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    fontWeight: 400
                  }}
                >
                  {caseStudyData.clientDescription}
                </p>
              </div> */}
            </div>

            {/* Bottom Section - Testimonial Paragraph */}
            <div className="w-full">
              <p 
                className="text-base sm:text-lg md:text-xl font-normal leading-relaxed"
                style={{ 
                  color: '#171717',
                  fontFamily: "'Bricolage Grotesque', sans-serif",
                  fontWeight: 400
                }}
              >
                {caseStudyData.testimonial}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="bg-white lg:py-8">
        <div className="max-w-7xl mx-auto w-full px-10">
          {/* Stats Layout - Horizontal for all screen sizes */}
          <div className="space-y-5 justify-center items-start">
            {caseStudyData.stats.map((stat, index) => (
              <div
                key={index}
                className="flex-1 flex flex-col max-w-none"
                style={{ fontFamily: 'Bricolage Grotesque, sans-serif' }}
              >
                {/* Large Blue Statistic */}
                <h3 
                  className="text-6xl font-extralight mb-3 sm:mb-4 md:mb-5"
                  style={{ 
                    color: '#6666FF',
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    lineHeight: '1.1'
                  }}
                >
                  {stat.number}
                </h3>

                {/* Description Text */}
                <p 
                  className="text-sm sm:text-base md:text-base lg:text-lg font-normal leading-relaxed"
                  style={{ 
                    color: '#171717',
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    fontWeight: 400
                  }}
                >
                  {stat.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default StatsCards;

